module.exports = __webpack_public_path__ + "img/primary-key.410fa626.svg";